import controller from './footer-core.controller';
import templateT1 from './templates/footer-core-t1.view.html';
import templateAD from './templates/footer-adaptative.html';

let FooterCoreComponent = {
  template: changeTemplate,
  controller,
  bindings: {
    shCtrl: '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  } else {
      return templateT1
  }
}

export default FooterCoreComponent;



/** WEBPACK FOOTER **
 ** ./www/components/footer-core/footer-core.component.js
 **/